import { render, staticRenderFns } from "./branch-list.vue?vue&type=template&id=6b24573f&"
import script from "./branch-list.vue?vue&type=script&lang=js&"
export * from "./branch-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports